import React from "react";
import { Link } from "react-router-dom";

const PaymentThanks = () => {
  return (
    <main className="myn-thanks" aria-labelledby="thanks-title">
      <section className="myn-thanks__card">
        <div className="myn-thanks__mark" aria-hidden="true">✓</div>
        <p className="myn-thanks__kicker">Zahlung</p>
        <h1 id="thanks-title">Vielen Dank</h1>
        <p className="myn-thanks__lead">
          Ihre Zahlung ist bei uns eingegangen. Sie können dieses Fenster schließen.
          Eine Bestätigung erhalten Sie vom Verkäufer.
        </p>
        <Link className="myn-btn myn-btn--primary" to="/">
          Zur Startseite
        </Link>
      </section>
    </main>
  );
};

export default PaymentThanks;
